import { render } from "./CobaltTaskForm.vue?vue&type=template&id=8dbfa3e6"
import script from "./CobaltTaskForm.vue?vue&type=script&lang=js"
export * from "./CobaltTaskForm.vue?vue&type=script&lang=js"

import "./CobaltTaskForm.vue?vue&type=style&index=0&id=8dbfa3e6&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__